import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { IAuthorizedRoute } from '../auth/types/can';

import { commonRoutes } from './common-routes';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

import { PropertyRouter } from '.';
import { AlertsMain } from '../features/alerts/alerts-main';
import { SourceMain } from '../features/sources/source-main';
import { TestSubscriptions } from '../features/infrastructure/gql-tests/TestSubscriptions';
import { NotFound } from '../features/not-found/not-found';
import { UsersMain } from '../features/users/users-main';
import { LoggingOut } from '../features/logging-out/logging-out';
import { UserDetail } from '../features/users/user-detail';
import { UserDetailBreadcrumb } from '../features/users/user-detail-breadcrumb';
import { UserProfileBreadcrumb } from '../features/userProfile/user-profile-breadcrumb';
import { UsersBreadcrumb } from '../features/users/users-breadcrumb';
import { Ingestions } from '../features/ingestions/ingestions';
import BulkConfig from '../features/bulkConfig/bulk-config';
import { UserProfile } from '../features/userProfile/user-profile';
import { SourceDetailHandler } from '../features/sources/ui/source-detail-handler';
import { ZonePoliciesMain } from '../features/zone-policies/zone-policies-main';
import { ZonePolicyDetail } from '../features/zone-policies/zone-policy-detail';
import { ZonePolicyDetailBreadcrumb } from '../features/zone-policies/zone-policy-detail-breadcrumb';
import { SetpointLimitProfilesMain } from '../features/setpoint-limit-profiles/setpoint-limit-profiles-main';
import { SetpointLimitProfileDetail } from '../features/setpoint-limit-profiles/setpoint-limit-profile-detail';
import { SetpointLimitProfileDetailBreadcrumb } from '../features/setpoint-limit-profiles/setpoint-limit-profile-detail-breadcrumb';
import { ZonePoliciesBreadcrumb } from '../features/zone-policies/zone-policies-breadcrumb';
import { SetpointLimitProfilesBreadcrumb } from '../features/setpoint-limit-profiles/setpoint-limit-profile-breadcrumb';
import { SubscriptionMonitor } from '../features/infrastructure/subscription-monitoring';
import { useSystemHistory } from '../ui/history/history-manager';
// import { OrganizationList } from '../features/organizations/organization-list';
import { OrganizationMain } from '../features/organizations/organization-main';
import { OrganizationDetailHandler } from '../features/organizations/ui/organization-detail-handler';
import { PlmCurtailmentPlanMain } from '../features/plm/plmCurtailmentPlan/plmCurtailmentPlan-main';
//import { PlmCurtailmentPlanList } from '../features/plm/plmCurtailmentPlan/plmCurtailmentPlan-list';
import { PlmCurtailmentPlanDetailView } from '../features/plm/plmCurtailmentPlan/plmCurtailmentPlan-detail-view';
import { PlmCurtailmentPlanDetailForm } from '../features/plm/plmCurtailmentPlan/plmCurtailmentPlan-detail-form';
import { PlmPartnerMain } from '../features/plm/plmPartner/plmPartner-main';
import { PlmPartnerDetail } from '../features/plm/plmPartner/plmPartner-detail';
import { PlmPartnerEdit } from '../features/plm/plmPartner/plmPartner-edit';
import { PlmPartnerAdd } from '../features/plm/plmPartner/plmPartner-add';
import { PlmProgramMain } from '../features/plm/plmProgram/plmProgram-main';
// import { PlmProgramList } from '../features/plm/plmProgram/plmProgram-list';
import { PlmProgramDetail } from '../features/plm/plmProgram/plmProgram-detail';
import { PlmProgramEdit } from '../features/plm/plmProgram/plmProgram-edit';
import { PlmProgramAdd } from '../features/plm/plmProgram/plmProgram-add';
import { PlmContractMain } from '../features/plm/plmContract/plmContract-main';
//import { PlmContractList } from '../features/plm/plmContract/plmContract-list';
import { PlmContractDetail } from '../features/plm/plmContract/plmContract-detail';
import { PlmContractEdit } from '../features/plm/plmContract/plmContract-edit';
import { PlmContractAdd } from '../features/plm/plmContract/plmContract-add';
import { PlmEventMain } from '../features/plm/plmEvent/plmEvent-main';
//import { PlmEventList } from '../features/plm/plmEvent/plmEvent-list';
import { PlmEventAdd } from '../features/plm/plmEvent/plmEvent-add';
import { PlmEventDetail } from '../features/plm/plmEvent/plmEvent-detail';
import { PlmEventEdit } from '../features/plm/plmEvent/plmEvent-edit';
import { PlmEventResponseMain } from '../features/plm/plmEventResponse/plmEventResponse-main';
//import { PlmEventResponseList } from '../features/plm/plmEventResponse/plmEventResponse-list';
import { PlmEventResponseAdd } from '../features/plm/plmEventResponse/plmEventResponse-add';
import { PlmEventResponseDetail } from '../features/plm/plmEventResponse/plmEventResponse-detail';
import { PlmEventResponseEdit } from '../features/plm/plmEventResponse/plmEventResponse-edit';
import { PlmEventResponseExternalLink } from '../features/plm/plmEventResponse/plmEventResponse-external-link';
import PlmResponseTimelineView from '../features/plm/plmEventResponse/components/plm-response-timeline-view';
import { PlmCalendar } from '../features/plm/plmCalendar';
import { UnitPlmCalendar } from '../features/plm/plmCalendar/UnitPlmCalendar';
import { PropertyContextWrapper } from '../features/properties/PropertyContextWrapper';
import { SystemNotificationList } from '../features/system-notifications/system-notification-list';
import { SystemNotificationEdit } from '../features/system-notifications/system-notification-edit';
import { SystemNotificationDetail } from '../features/system-notifications/system-notification-detail';
import { DeviceOfflineReport } from '../features/properties/device-offline-report';
import { QuarterlyReportsData } from '../features/reports/quarterly-reports-data';

export type AuthorizedRoute = BreadcrumbsRoute & IAuthorizedRoute;
export type AuthorizedRoutes = AuthorizedRoute[];

export const DefaultRoute: AuthorizedRoute = {
  path: '*',
  element: <NotFound />,
  state: { to: '/not-found' },
};

const HistoricRoute = () => {
  const { last, hasLast, currentIndex, stack } = useSystemHistory();
  const { pathname, state, search } = useLocation();

  let toRoute = '/properties';

  if (pathname === '/' && stack.length > 0) {
    toRoute = stack[stack.length - 1][0];
  }

  return <Navigate to={toRoute} replace />;
};

export const defaultRoutes = [DefaultRoute];

// noinspection JSUnusedLocalSymbols
export const appRoutes: AuthorizedRoutes = [
  ...commonRoutes,
  {
    path: '/',
    // TODO: Peter: in the future, the page redirected to might be dependent on the user's settings
    element: <HistoricRoute />,
    authType: 'Property',
  },
  {
    path: '/logging-out',
    element: <LoggingOut />,
    // authType: 'viewer',
  },
  {
    path: '/login',
    // TODO: Peter: in the future, the page redirected to might be dependent on the user's settings
    element: <Navigate to="/properties" replace />,
    authType: 'Property',
  },
  {
    path: '/organizations',
    element: <OrganizationMain />,
    authType: 'Organization',
  },
  // {
  //   path: '/organizations',
  //   element: <OrganizationList />,
  //   authType: 'Organization',
  // },
  {
    path: '/organizations/add-organization',
    element: <OrganizationDetailHandler />,
    authType: 'Organization',
    authAction: 'create',
  },
  {
    path: '/organizations/:id/view-organization',
    element: <OrganizationDetailHandler />,
    authType: 'Organization',
    authAction: 'view',
  },
  {
    path: '/organizations/:id/edit-organization',
    element: <OrganizationDetailHandler />,
    authType: 'Organization',
    authAction: 'update',
  },
  {
    path: '/properties/*',
    element: <PropertyRouter />,
    authType: 'Property',
  },
  {
    path: '/alerts',
    element: <AlertsMain />,
    authType: 'Alert',
  },
  {
    path: '/reports',
    element: <Navigate to="/reports/real-time-testing" replace />,
    authType: 'Reports',
    authAction: 'index',
  },
  {
    path: '/reports/device-offline',
    element: <DeviceOfflineReport />,
    authType: 'Reports',
    authAction: 'index',
  },
  {
    path: '/reports/quarterly-reports-data',
    element: <QuarterlyReportsData />,
    authType: 'Reports',
    authAction: 'extract_quarterly_data',
  },
  {
    path: '/reports/real-time-testing',
    element: <TestSubscriptions />,
    authType: 'Reports',
    authAction: 'index',
  },
  {
    path: '/system-notifications',
    element: <SystemNotificationList />,
    authType: 'SystemNotification' as any,
  },
  {
    path: '/system-notifications/create',
    element: <SystemNotificationEdit />,
    authType: 'SystemNotification' as any,
    authAction: 'create',
  },
  {
    path: '/system-notifications/:id',
    element: <SystemNotificationDetail />,
    authType: 'SystemNotification' as any,
    authAction: 'view',
  },
  {
    path: '/system-notifications/:id/edit',
    element: <SystemNotificationEdit />,
    authType: 'SystemNotification' as any,
    authAction: 'update',
  },
  {
    path: '/sources',
    element: <SourceMain />,
    authType: 'Source',
  },
  {
    path: '/sources/create',
    element: <SourceDetailHandler />,
    authType: 'Source',
    authAction: 'create',
  },
  {
    path: '/sources/:id/view-source',
    element: <SourceDetailHandler />,
    authType: 'Source',
    authAction: ['view'],
  },
  {
    path: '/sources/:id/edit-source',
    element: <SourceDetailHandler />,
    authType: 'Source',
    authAction: ['update', 'view'],
  },
  {
    path: '/users',
    element: <UsersMain />,
    breadcrumb: ({
      match: {
        params: { userId },
      },
    }) => <UsersBreadcrumb />,
    authType: 'User',
  },
  {
    path: '/users/create',
    element: <UserDetail />,
    breadcrumb: ({
      match: {
        params: { userId },
      },
    }) => <UserDetailBreadcrumb id={userId} />,
    authType: 'User',
    authAction: 'create',
  },
  {
    path: '/users/create/tab/general',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'create',
  },
  {
    path: '/users/create/tab/manager',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'create',
  },
  {
    path: '/users/create/tab/installer',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'create',
  },
  {
    path: '/users/create/tab/resident',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'create',
  },
  {
    path: '/users/create/tab/viewer',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'create',
  },
  {
    path: '/users/:userId',
    element: <UserDetail />,
    breadcrumb: ({
      match: {
        params: { userId },
      },
    }) => <UserDetailBreadcrumb id={userId} />,
    authType: 'User',
    authAction: 'update',
    state: {
      ignore: [/^\/users\/[a-zA-Z0-9]+\/profile$/, /^\/users\/[a-zA-Z0-9]+\/$/],
    },
  },
  {
    path: '/users/:userId/tab/general',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'update',
  },
  {
    path: '/users/:userId/tab/manager',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'update',
  },
  {
    path: '/users/:userId/tab/installer',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'update',
  },
  {
    path: '/users/:userId/tab/resident',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'update',
  },
  {
    path: '/users/:userId/tab/viewer',
    element: <UserDetail />,
    authType: 'User',
    authAction: 'update',
  },
  {
    path: '/users/:userId/tab',
    element: <UserDetail />,
    state: {
      ignore: [/^\/users\/[a-zA-Z0-9]+\/profile$/, /^\/users\/[a-zA-Z0-9]+\/$/],
    },
  },
  {
    path: '/users/:userId/profile/:viewId',
    element: <UserProfile />,
    breadcrumb: ({
      match: {
        params: { userId },
      },
    }) => <UserProfileBreadcrumb id={userId} />,
    authType: 'User',
    authAction: 'updateProfile',
  },
  {
    path: '/users/:userId/profile',
    element: <UserProfile />,
    breadcrumb: ({
      match: {
        params: { userId },
      },
    }) => <UserProfileBreadcrumb id={userId} />,
    state: {
      ignore: [/^\/users\/[a-zA-Z0-9]+\/profile$/, /^\/users\/[a-zA-Z0-9]+\/$/],
    },
    authType: 'User',
    authAction: 'updateProfile',
  },
  {
    path: '/bulk-config',
    element: <BulkConfig />,
    authType: 'BulkConfig',
  },
  {
    path: '/ingestions',
    element: <Ingestions />,
    authType: 'Ingestion',
  },
  {
    path: '/setpoint-profiles',
    element: <SetpointLimitProfilesMain />,
    breadcrumb: ({
      match: {
        params: { setpointProfileId },
      },
    }) => <SetpointLimitProfilesBreadcrumb />,
    authType: 'SetpointProfile',
  },
  {
    path: '/setpoint-profiles/create',
    element: <SetpointLimitProfileDetail />,
    breadcrumb: () => <SetpointLimitProfileDetailBreadcrumb />,
    authType: 'SetpointProfile',
    authAction: 'create',
  },
  {
    path: '/setpoint-profiles/profile/:setpointProfileId',
    element: <SetpointLimitProfileDetail />,
    breadcrumb: ({
      match: {
        params: { setpointProfileId },
      },
    }) => <SetpointLimitProfileDetailBreadcrumb id={setpointProfileId} />,
    authType: 'SetpointProfile',
    authAction: 'update',
  },

  {
    path: '/zone-policies',
    element: <ZonePoliciesMain />,
    breadcrumb: ({
      match: {
        params: { zonePolicyId },
      },
    }) => <ZonePoliciesBreadcrumb />,
    authType: 'ZonePolicy',
  },
  {
    path: '/zone-policies/create',
    element: <ZonePolicyDetail />,
    breadcrumb: () => <ZonePolicyDetailBreadcrumb />,
    authType: 'ZonePolicy',
    authAction: 'create',
  },
  {
    path: '/zone-policies/:zonePolicyId',
    element: <ZonePolicyDetail />,
    breadcrumb: ({
      match: {
        params: { zonePolicyId },
      },
    }) => <ZonePolicyDetailBreadcrumb id={zonePolicyId} />,
    authType: 'ZonePolicy',
    authAction: 'update',
  },
  // TODO: Peter: might not actually need this?
  {
    path: '/logging-out',
    element: <LoggingOut />,
  },
  {
    path: '/subscription-monitoring',
    element: <SubscriptionMonitor />,
    authType: 'SubscriptionMonitoring',
    authAction: 'read',
  },
  {
    path: '/plmPartners',
    element: <PlmPartnerMain />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmPartners/add-plmPartner',
    element: <PlmPartnerAdd />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmPartners/:id/view-plmPartner',
    element: <PlmPartnerDetail />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmPartners/:id/edit-plmPartner',
    element: <PlmPartnerEdit />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmPrograms',
    element: <PlmProgramMain />,
    authType: 'super',
    authAction: 'be',
  },
  // {
  //   path: '/plmPrograms',
  //   element: <PlmProgramList />,
  //   authType: 'PlmProgram' as SubjectTypes,
  // },
  {
    path: '/plmPrograms/add-plmProgram',
    element: <PlmProgramAdd />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmPrograms/:id/view-plmProgram',
    element: <PlmProgramDetail />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmPrograms/:id/edit-plmProgram',
    element: <PlmProgramEdit />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmCurtailmentPlan',
    element: <PlmCurtailmentPlanMain />,
    authType: 'super',
    authAction: 'be',
  },
  // {
  //   path: '/plmCurtailmentPlan',
  //   element: <PlmCurtailmentPlanList />,
  //   authType: 'PlmCurtailmentPlan' as SubjectTypes,
  // },
  {
    path: '/plmCurtailmentPlan/:id',
    element: <PlmCurtailmentPlanDetailView />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmCurtailmentPlan/:id/edit',
    element: <PlmCurtailmentPlanDetailForm />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmCurtailmentPlan/new',
    element: <PlmCurtailmentPlanDetailForm />,
    authType: 'super',
    authAction: 'be',
  },
  // {
  //   path: '/plmContracts',
  //   element: <PlmContractList />,
  //   authType: 'PlmContract' as SubjectTypes,
  // },
  {
    path: '/plmContracts',
    element: <PlmContractMain />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmContracts/add-plmContract',
    element: <PlmContractAdd />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmContracts/:id/view-plmContract',
    element: <PlmContractDetail />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plmContracts/:id/edit-plmContract',
    element: <PlmContractEdit />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm-events',
    element: <PlmEventMain />,
    authType: 'super',
    authAction: 'be',
  },
  // {
  //   path: '/plm-events',
  //   element: <PlmEventList />,
  //   authType: 'PlmEvent' as SubjectTypes,
  // },
  {
    path: '/plm-events/add',
    element: <PlmEventAdd />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm-events/:id',
    element: <PlmEventDetail />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm-events/:id/edit',
    element: <PlmEventEdit />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm-event-responses',
    element: <PlmEventResponseMain />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm-response-link',
    element: <PlmEventResponseExternalLink />,
    authType: 'super',
    authAction: 'be',
  },
  // {
  //   path: '/plm-event-responses',
  //   element: <PlmEventResponseList />,
  //   authType: 'PlmEventResponse' as SubjectTypes,
  // },
  {
    path: '/plm-event-responses/add',
    element: <PlmEventResponseAdd />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm-event-responses/:id',
    element: <PlmEventResponseDetail />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm-event-responses/:id/edit',
    element: <PlmEventResponseEdit />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm/event-responses/:id/timeline',
    element: <PlmResponseTimelineView />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm/calendar',
    element: <PlmCalendar />,
    authType: 'super',
    authAction: 'be',
  },
  {
    path: '/plm/unit-calendar',
    element: <UnitPlmCalendar />,
    authType: 'super',
    authAction: 'be',
  },
  DefaultRoute,
];

export const routes = appRoutes;
